/* MJade - Collection Grid Mobile Color Rail
 * 2026-09-17 — 일본 정본(assets/mjade-best-sellers-mobile.js v11)을 «그대로» 옮겼다.
 *   바꾼 것은 글자뿐: '+N色' → '+N more', '他のN色を表示' → 'Show N more colors'.
 *   그리고 남는 색이 0이면 라벨을 감추는 한 가지를 보탰다(일본에도 있는 구멍).
 * 접히는 때 : 라벨을 다시 눌러서가 아니라, «다른 상품이나 빈 곳을 누를 때» 접힌다.
 *             (closeOthers - pointerdown/touchstart 가로채기)
 * 애니메이션 : 라벨 6px 빠짐 .28s → 200ms 뒤 칩이 -8px 에서 45ms 씩 늦게 들어옴.
 *             접을 땐 뒤에서부터 거꾸로. 정리 320 + 순번x45ms. data-mj-busy 로 중복 방지.
 */
(function(){
  'use strict';
  if (window.__mjBSRailInit) return;
  window.__mjBSRailInit = true;

  var MOBILE_MAX = 767;
  var RAIL_SEL = '.product-block-options--swatch';
  var VISIBLE = 3;
  var MORE_W_EST = 46;
  var SW_MAX = 36, SW_MIN = 24, GAP_MAX = 8, GAP_MIN = 6;

  function isMobile(){ return window.matchMedia('(max-width: ' + MOBILE_MAX + 'px)').matches; }
  function isCollectionGrid(){ return document.body.classList.contains('template-collection'); }

  var eagerApplied = false;
  function eagerAll(){
    /* ★ 2026-09-02 — PC 에서도 돌게 열었다 (대표님 지시). 전에는 여기서 막혀 PC 는 「+N more」가 안 먹었다. */
    var imgs = document.querySelectorAll(RAIL_SEL + ' img[loading="lazy"]');
    for (var i = 0; i < imgs.length; i++) { imgs[i].setAttribute('loading', 'eager'); }
    if (imgs.length > 0) eagerApplied = true;
  }

  function railItems(rail){
    return Array.prototype.slice.call(
      rail.querySelectorAll('.product-block-options__item')
    );
  }
  function moreLabel(rail){ return rail.querySelector('.product-block-options__more-label'); }

  function solveShrink(W){
    for (var sw = 30; sw >= SW_MIN; sw--){
      for (var gap = GAP_MAX; gap >= GAP_MIN; gap--){
        if (VISIBLE*sw + (VISIBLE-1)*gap + gap + MORE_W_EST <= W - 2) return {sw: sw, gap: gap};
      }
    }
    return {sw: SW_MIN, gap: GAP_MIN};
  }

  function layoutRail(rail){
    /* ★ 2026-09-02 — PC 에서도 돌게 열었다 (대표님 지시). 전에는 여기서 막혀 PC 는 「+N more」가 안 먹었다. */
    var inner = rail.querySelector('.product-block-options__inner');
    if (!inner) return;
    var items = railItems(rail);
    var more = moreLabel(rail);
    var total = items.length;
    if (total === 0) return;

    if (rail.getAttribute('data-mj-open') === '1') return;

    var W = inner.clientWidth || inner.getBoundingClientRect().width;
    if (!W) return;

    var needAll = total*SW_MAX + (total-1)*GAP_MAX;
    /* MJade 2026-09-04 (대표님 지시) — 폭이 남아도 «개수» 로 먼저 자른다.
       전에는 폭만 봤다: 4색은 4×36+3×8 = 168px 라 174px 안에 들어가서
       안 접혔고, 5색(212px)부터 접혔다. 그래서 카드마다 스와치 수가 달라 보였다.
       이제 VISIBLE(3) 을 넘으면 폭과 무관하게 접는다 → 4색은 3개 + 「+1 more」. */
    if (total <= VISIBLE && needAll <= W + 0.5){
      rail.setAttribute('data-mj-mode', 'all');
      rail.style.removeProperty('--mj-sw');
      rail.style.removeProperty('--mj-gap');
      items.forEach(function(it){ it.style.removeProperty('display'); });
      if (more) more.style.setProperty('display', 'none', 'important');
      return;
    }

    var needVis = VISIBLE*SW_MAX + (VISIBLE-1)*GAP_MAX + GAP_MAX + MORE_W_EST;
    if (needVis > W - 2){
      var sol = solveShrink(W);
      rail.style.setProperty('--mj-sw', sol.sw + 'px');
      rail.style.setProperty('--mj-gap', sol.gap + 'px');
    } else {
      rail.style.removeProperty('--mj-sw');
      rail.style.removeProperty('--mj-gap');
    }

    rail.setAttribute('data-mj-mode', 'more');
    // MJade 2026-09-01 — 이 카드가 대표하는 색(--mj-on)은 «절대 접지 않는다».
    //   왜: 목록에서 한 상품을 색깔별 카드로 쪼갠 뒤, 블랙 카드인데 블랙 스와치가
    //   안 보이는 일이 났다(2026-09-01 430px 실측). Liquid 에서 접힘을 조정해도
    //   이 함수가 나중에 앞 3개만 남기고 덮어썼다.
    //   보이는 개수는 그대로 VISIBLE 개다 — 자리만 바꾼다(폭 계산에 영향 없음).
    var mjOn = -1;
    for (var k = 0; k < total; k++){
      if (items[k].classList.contains('product-block-options__item--mj-on')){ mjOn = k; break; }
    }
    var mjShow = [];
    for (var k2 = 0; k2 < total && mjShow.length < VISIBLE; k2++) mjShow.push(k2);
    if (mjOn >= VISIBLE && mjShow.length) mjShow[mjShow.length - 1] = mjOn;
    items.forEach(function(it, i){
      if (mjShow.indexOf(i) >= 0) it.style.removeProperty('display');
      else it.style.setProperty('display', 'none', 'important');
    });
    if (more){
      var remaining = total - VISIBLE;
      /* MJade 2026-09-17 — 남는 색이 없으면 라벨을 감춘다.
         위 조건은 «3개 이하면서 폭에 들어갈 때»만 전부 보여준다. 3개인데 폭이 모자라면
         여기로 내려와 «+0 more» 가 될 수 있다. 일본 원문에도 있는 구멍이라 우리만 막는다. */
      if (remaining <= 0){
        more.style.setProperty('display', 'none', 'important');
        items.forEach(function(it){ it.style.removeProperty('display'); });
        return;
      }
      more.textContent = '+' + remaining + ' more';
      more.style.setProperty('display', 'inline-flex', 'important');
      more.setAttribute('role', 'button');
      more.setAttribute('tabindex', '0');
      more.setAttribute('aria-label', 'Show ' + remaining + ' more colors');
    }
  }

  /* ★ 2026-09-02 — 한국몰과 같은 동작·같은 속도로 펼치고 접는다.
     원문: m.mjade.co.kr 목록의 함수 「접기」 (2026-09-01 내려받아 확인)
       단추 : translate3d(6px,0,0) + opacity 0, .28s ease → 200ms 뒤 감춤
       칩   : translate3d(-8px,0,0)+opacity 0 에서 시작, .28s ease,
              순번마다 45ms 씩 늦게, 정리는 320 + 순번×45 ms
     접힘은 한국에 없다(한 번 펼치면 그대로). 같은 값을 거꾸로 돌려 만들었다. */
  var EASE28 = 'transform .28s ease, opacity .28s ease';
  var STEP = 45, HOLD = 200, CLEAN = 320;

  function chipReset(it){
    it.style.transition = '';
    it.style.transitionDelay = '';
    it.style.transform = '';
    it.style.opacity = '';
  }

  function expandRail(rail){
    /* ★ 2026-09-02 — PC 에서도 돌게 열었다 (대표님 지시). 전에는 여기서 막혀 PC 는 「+N more」가 안 먹었다. */
    if (rail.getAttribute('data-mj-busy') === '1') return;
    var items = railItems(rail);
    var more = moreLabel(rail);
    rail.setAttribute('data-mj-open', '1');
    rail.setAttribute('data-mj-mode', 'open');
    rail.setAttribute('data-mj-busy', '1');

    if (more){
      more.style.transition = EASE28;
      more.style.transform = 'translate3d(6px,0,0)';
      more.style.opacity = '0';
    }
    setTimeout(function(){
      if (more) more.style.setProperty('display', 'none', 'important');
      var hidden = items.filter(function(it){ return it.style.display === 'none'; });
      hidden.forEach(function(it, k){
        it.style.removeProperty('display');
        it.style.transition = 'none';
        it.style.transform = 'translate3d(-8px,0,0)';
        it.style.opacity = '0';
        void it.offsetWidth;                 /* 리플로우 — 없으면 안 움직인다 */
        it.style.transition = EASE28;
        it.style.transitionDelay = (k * STEP) + 'ms';
        it.style.transform = 'translate3d(0,0,0)';
        it.style.opacity = '1';
        setTimeout(function(){ chipReset(it); }, CLEAN + k * STEP);
      });
      setTimeout(function(){ rail.removeAttribute('data-mj-busy'); },
                 CLEAN + hidden.length * STEP);
    }, HOLD);
  }

  /* 밖에서도 부를 수 있게 열어 둔다 (theme.liquid 의 soloRail 이 쓴다) */
  function collapseRail(rail){
    if (!rail || rail.getAttribute('data-mj-open') !== '1') return;
    if (rail.getAttribute('data-mj-busy') === '1') return;
    var items = railItems(rail);
    var more = moreLabel(rail);
    var vis = items.filter(function(it){ return it.style.display !== 'none'; });
    var extra = vis.slice(VISIBLE);          /* 접을 것 — 뒤에서부터 사라진다 */
    rail.setAttribute('data-mj-busy', '1');
    extra.slice().reverse().forEach(function(it, k){
      it.style.transition = EASE28;
      it.style.transitionDelay = (k * STEP) + 'ms';
      it.style.transform = 'translate3d(-8px,0,0)';
      it.style.opacity = '0';
    });
    setTimeout(function(){
      extra.forEach(chipReset);
      rail.removeAttribute('data-mj-open');
      var inner = rail.querySelector('.product-block-options__inner');
      if (inner) inner.scrollLeft = 0;       /* 안 되돌리면 다시 펼칠 때 엉뚱한 데서 시작한다 */
      layoutRail(rail);                      /* 세 개만 보이기 + N more 다시 표시 */
      if (more){
        more.style.transition = 'none';
        more.style.transform = 'translate3d(6px,0,0)';
        more.style.opacity = '0';
        void more.offsetWidth;
        more.style.transition = EASE28;
        more.style.transform = 'translate3d(0,0,0)';
        more.style.opacity = '1';
        setTimeout(function(){
          more.style.transition = '';
          more.style.transform = '';
          more.style.opacity = '';
        }, CLEAN);
      }
      rail.removeAttribute('data-mj-busy');
    }, CLEAN + extra.length * STEP);
  }
  window.__mjRailCollapse = collapseRail;
  /* 2026-09-03 — 접힌 «원래 모습» 을 다시 만들라고 부르는 창구 (mjade-card-hint.js 가 쓴다).
     힌트가 색칩을 잠깐 열어 보인 뒤 되돌릴 때 쓴다. 접는 규칙은 여기 한 곳에만 둔다. */
  window.__mjRailLayout = layoutRail;

  /* ★ 2026-09-02 — «펼친 줄은 하나뿐». 다른 상품을 만지거나 빈 곳을 누르면 닫는다.
     가로채기 단계에서 본다 — 카드 안의 처리기가 이벤트를 멈춰도 우리는 먼저 본다. */
  function closeOthers(e){
    var open = document.querySelectorAll(RAIL_SEL + '[data-mj-open="1"]');
    if (!open.length) return;
    var here = e.target && e.target.closest ? e.target.closest('.product-block') : null;
    for (var i = 0; i < open.length; i++){
      var card = open[i].closest('.product-block');
      if (card && card === here) continue;   /* 같은 상품 안이면 그대로 둔다 */
      collapseRail(open[i]);
    }
  }
  document.addEventListener('pointerdown', closeOthers, true);
  document.addEventListener('touchstart', closeOthers, { capture: true, passive: true });

  /* ★ 2026-09-02 — «화면 밖으로 나가면 닫기» 를 없앴다 (대표님 지시).
     썸네일에 마우스를 올려 사진이 바뀌는 동안에도 줄이 닫혀 버렸다.
     이제 닫히는 때는 둘뿐: 다른 상품을 누를 때 · 빈 곳을 누를 때. */

  function layoutAll(){
    /* ★ 2026-09-02 — PC 에서도 돌게 열었다 (대표님 지시). 전에는 여기서 막혀 PC 는 「+N more」가 안 먹었다. */
    document.querySelectorAll(RAIL_SEL).forEach(layoutRail);
  }

  function onMoreActivate(e){
    var more = e.target.closest && e.target.closest('.product-block-options__more-label');
    if (!more) return;
    if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') return;
    var rail = more.closest('.product-block-options--swatch');
    if (!rail) return;
    e.preventDefault();
    e.stopPropagation();
    expandRail(rail);
  }

  var ro = null;
  function observe(){
    if (!('ResizeObserver' in window)) return;
    ro = new ResizeObserver(function(entries){
      entries.forEach(function(en){
        var rail = en.target.closest ? en.target.closest(RAIL_SEL) : null;
        if (rail) layoutRail(rail);
      });
    });
    document.querySelectorAll(RAIL_SEL + ' .product-block-options__inner').forEach(function(inner){
      ro.observe(inner);
    });
  }

  function init(){
    if (!isCollectionGrid()) return;
    eagerAll();
    layoutAll();
    observe();
    document.addEventListener('click', onMoreActivate, true);
    document.addEventListener('keydown', onMoreActivate, true);
    window.addEventListener('resize', function(){ eagerAll(); layoutAll(); });
    window.addEventListener('orientationchange', function(){ setTimeout(function(){ eagerApplied=false; eagerAll(); layoutAll(); }, 200); });
    window.addEventListener('pageshow', function(){ eagerApplied=false; eagerAll(); layoutAll(); });
    if (document.fonts && document.fonts.ready){ document.fonts.ready.then(layoutAll); }
    window.addEventListener('load', layoutAll);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
